import { arrConcat } from '../fun-js-lib/arr'
import { htmlTagged } from '../fun-js-lib/html'

export function getWorkDescriptionAndRemarksInputs () {
  return arrConcat([workDescriptionInputs(), remarksInputs()])
}

export function workDescriptionInputs () {
  return htmlTagged(workDescriptionContainer(), 'input')
}

export function remarksInputs () {
  return htmlTagged(remarksContainer(), 'input')
}

function workDescriptionContainer () {
  return document.getElementById('workDescriptionContainer')
}

function remarksContainer () {
  return document.getElementById('remarksContainer')
}